import React from 'react'

function home() {
    return (
        <div>
            <h1>Home</h1>
        </div>
    )
}

export default home
